export default {
  schoolsNetwork: 'Red de escuelas',
  school: 'Escuela',
  cue: 'CUE: {n}',
  bioLabel: 'Bio',
  managers: 'Directivos',
  team: 'Equipo',
  levels: 'Niveles que imparte',
  mail: 'Correo electrónico',
  students: 'Cantidad de estudiantes',
  charactersLeft: '{n} caracteres | {n} caracter | {n} caracteres',
  edition: {
    schoolName: 'Nombre Escuela',
    cue: 'Clave Única de Establecimiento',
    schoolGroupName: 'Nombre de red de escuelas'
  },
  manageTeamTooltip: 'Administrar equipo',
  seeTeamTooltip: 'Ver equipo',
  emailError: 'Correo inválido. Prueba formato nombre@mail.com',
  toastErrors: {
    email: 'Hubo un problema al guardar cambios. Email invalido',
    imageType: 'Sólo se permiten imágenes con extensión jpg, jpeg y png.',
    imageSize: 'Sólo se permiten imágenes con un peso menor a 2MB.',
    requiredFields: 'El nombre de red de escuelas, el nombre de la escuela y la dirección son campos obligatorios'
  },
  managersAdded: 'Directivo agregado | Directivos agregados',
  managersRemoved: 'Directivo removido | Directivos removidos',
  changesSaved: 'Cambios guardados',
  membersAdded: 'Miembro agregado al equipo | Miembros agregados al equipo',
  membersRemoved: 'Miembro removido del equipo | Miembros removidos del equipo'
}

export const en = {
  schoolsNetwork: 'Schools network',
  school: 'School',
  cue: 'UCK: {n}',
  bioLabel: 'Bio',
  managers: 'Directors',
  team: 'Team',
  levels: 'Levels taught',
  mail: 'Mail',
  students: 'Number of students',
  charactersLeft: '{n} characters | {n} character | {n} characters',
  edition: {
    schoolName: 'School name',
    cue: 'Unique Center Key',
    schoolGroupName: 'School group name'
  },
  manageTeamTooltip: 'Manage team',
  seeTeamTooltip: 'View team',
  emailError: 'Invalid email. Try name@mail.com format',
  toastErrors: {
    email: 'Failed to save changes. Invalid email',
    imageType: 'Image files must be jpg, jpeg and png extension.',
    imageSize: 'Image files must be under 2MB.',
    requiredFields: 'The schools network, school name and address are mandatory fields'
  },
  managersAdded: 'Director added | Directors added',
  managersRemoved: 'Director removed | Directors removed',
  changesSaved: 'Changes saved',
  membersAdded: 'Member added to team | Members added to team',
  membersRemoved: 'Member removed from team | Members removed from team'
}

export const ca = {
  schoolsNetwork: 'Xarxa d\'escoles',
  school: 'Escola',
  cue: 'CUE: {n}',
  bioLabel: 'Bio',
  managers: '  Directius',
  team: 'Equip',
  levels: 'Nivells que imparteix',
  mail: 'Correu electrònic',
  students: 'Quantitat d\'estudiants',
  charactersLeft: '{n} caràcters | {n} caràcter | {n} caràcters',
  edition: {
    schoolName: 'Nom de l\'Escola',
    cue: 'Clau Única d\'Establiment',
    schoolGroupName: 'Nom de xarxa escolar'
  },
  manageTeamTooltip: 'Administrar equip',
  seeTeamTooltip: 'Veure equip',
  emailError: 'CCorreu invàlid. Prova de format nom@mail.com',
  toastErrors: {
    email: 'Hi ha hagut un problema desant els canvis. Correu electrònic no vàlid',
    imageType: 'Només es permeten imatges amb extensió jpg, jpeg i png.',
    imageSize: 'Només es permeten imatges amb un pes inferior a 2 MB.',
    requiredFields: 'El nom de la xarxa d\'escoles, el nom de l\'escola i la direcció son camps obligatoris'
  },
  managersAdded: 'Directiu afegit | Directius afegits',
  managersRemoved: 'Directiu eliminat | Directius eliminats',
  changesSaved: 'Canvis desats',
  membersAdded: 'Membre afegit a l\'equip | Membres afegits a l\'equip',
  membersRemoved: 'Membre eliminat de l\'equip | Membres eliminats de l\'equip'
}
